
import {Component, Mixins, Prop, Ref, Watch} from "vue-property-decorator";
import FormWrapper from "@/components/FormWrapper.vue";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import SimpleInputMixin from "@/mixins/SimpleInputMixin.vue";
import {MDB} from "@/plugins/uyap-plugin/MDB";
import Crypto from "crypto";

@Component({
  components: {DeleteDialog, FormWrapper}
})
export default class EvrakEkleForm extends Mixins(SimpleInputMixin) {
  @Ref('form') readonly form!: FormWrapper;

  mdb = new MDB();
  localValue!: {
    seciliTur: any,
    aciklama: string,
    dosya: File,
    dosyaData: {
      base64: string | null,
      name: string | null,
      type: string | null,
      dosya: Blob | null,
      hash: string
    },
    ekDosyalar: Array<File>,
    ekDosyalarData: Array<{
      base64: string | null,
      name: string | null,
      type: string | null,
      dosya: Blob | null,
      hash: string
    }>
  };

  /** Önceki convertToBase64 + split tabanlı SHA1 ile aynı sonuç (base64 parçası üzerinden). */
  private hashFromArrayBuffer(buffer: ArrayBuffer): string {
    const bytes = new Uint8Array(buffer);
    let binary = '';
    for (let i = 0; i < bytes.byteLength; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    const base64Part = btoa(binary);
    return Crypto.createHash('sha1').update(base64Part).digest().toString('hex');
  }

  async onDosyaChange(file: File | null) {
    if (file) {
      const buffer = await file.arrayBuffer();
      const blob = new Blob([buffer], {type: file.type || 'application/octet-stream'});
      this.localValue.dosyaData.base64 = null;
      this.localValue.dosyaData.dosya = blob;
      this.localValue.dosyaData.name = file.name;
      this.localValue.dosyaData.type = file.type;
      this.localValue.dosyaData.hash = this.hashFromArrayBuffer(buffer);
    } else {
      this.localValue.dosyaData = {base64: null, name: null, type: null, dosya: null, hash: ''};
    }
  }

  async onEkDosyaChange(files: File | File[] | null | undefined) {
    this.localValue.ekDosyalarData = [];
    const list: File[] = Array.isArray(files) ? files : files ? [files] : [];
    if (list.length === 0) {
      return;
    }
    for (const file of list) {
      const buffer = await file.arrayBuffer();
      const blob = new Blob([buffer], {type: file.type || 'application/octet-stream'});
      this.localValue.ekDosyalarData.push({
        base64: null,
        name: file.name,
        type: file.type,
        dosya: blob,
        hash: this.hashFromArrayBuffer(buffer)
      });
    }
  }

  fileRule(dosya: any, zorunluMu: boolean) {
    if (dosya) {
      let uzanti = dosya.name.split('.').pop();
      if (["udf", "pdf", "jpg", "jpeg", "png", "tif", "tiff", "UDF", "PDF", "JPG", "JPEG", "PNG", "TIF", "TIFF"].indexOf(uzanti) >= 0) {
        if (dosya.size < 10485760)
          return true;
        else
          return "Doküman boyutu 10MB'dan fazla olamaz.";
      } else
        return "Doküman formatı UYAP'a uygun değil."
    } else {
      if (zorunluMu)
        return 'Lütfen bu alanı doldurun.';
      else
        return true;
    }
  }
}
